import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { AroAngularTrackComponent } from './aro-angularTrack.component';
import { AcousticVectorObject } from '@core_n/asp/AcousticVectorObject';

@Injectable({
  providedIn: 'root'
})
export class AroAngTrackService {
  
  private dialogRef: MatDialogRef<any>;
  private dialogRefArr: MatDialogRef<any>[] = [];
  
  constructor(private dialog: MatDialog) { }

  showAngTrack(AcousticVector: AcousticVectorObject) {
    this.dialogRef = this.getFromArr(AcousticVector.Data.ID);
    if (this.dialogRef && this.dialogRef.getState() == MatDialogState.OPEN) {
      let angTrackComp = this.dialogRef.componentInstance as AroAngularTrackComponent;
      angTrackComp.setAngTrack(AcousticVector);
      angTrackComp.dialogRaise()
    }
    else {
      this.dialogRef = this.dialog.open(AroAngularTrackComponent, AroAngularTrackComponent.createDialogConfig(AcousticVector));
      this.dialogRefArr.push(this.dialogRef);
      let trackComp = this.dialogRef.componentInstance as AroAngularTrackComponent;
      trackComp.setAngTrack(AcousticVector);
      trackComp.dialogRaise();
    }
  }

  // search if the componant is already open by id of ang track...
  // refTrackAro (the componant).angTrack (the angular track of that componant).Data (the main data of that Ang track).ID (ID)
  getFromArr(num: any): any {
    let Ref: MatDialogRef<any> = null;
    this.removeGarbage();

    this.dialogRefArr.forEach((ref) => {
      let refTrackAro = ref.componentInstance as AroAngularTrackComponent;
      if (refTrackAro) {
        if (num == refTrackAro.angTrack.Data.ID) {
          Ref = ref;
          return;
        }
      }
    })
    return Ref;
  }

  removeGarbage() {
    this.dialogRefArr = this.dialogRefArr.filter(ele => {
      return(ele != null && ele !== undefined && ele.getState() != MatDialogState.CLOSED);
    })
  }
}
